var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapSwitchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Empty",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 69,
    viewBox: "0 0 202 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 202,
    height: 69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M86.23,68.35c-.09,0-.13-.01-79.38-12.43A7.02,7.02,0,0,1,.92,49.1L.65,9.97A4.152,4.152,0,0,1,1.83,6.99,4.084,4.084,0,0,1,4.77,5.75h.6c56.14-.06,101.63-.1,135.23-.1,29.05,0,47.77.03,55.63.08a4.767,4.767,0,0,1,4.75,4.75l.37,53.37a4.439,4.439,0,0,1-4.44,4.49H86.23Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M140.53,6.3c25.53,0,46.9.02,55.7.08a4.132,4.132,0,0,1,4.1,4.1l.37,53.37a3.784,3.784,0,0,1-3.78,3.84H86.23c-.05,0-79.28-12.42-79.28-12.42a6.385,6.385,0,0,1-5.38-6.19L1.3,9.96A3.485,3.485,0,0,1,4.77,6.4c16.58-.02,84.53-.1,135.76-.1m0-1.3c-23.15,0-65.41.02-135.28.1H4.77A4.735,4.735,0,0,0,1.36,6.54,4.792,4.792,0,0,0,0,9.99L.27,49.1a7.686,7.686,0,0,0,6.48,7.47C86.03,68.99,86.06,68.99,86.13,69H196.92A5.088,5.088,0,0,0,202,63.84l-.37-53.36a5.414,5.414,0,0,0-5.39-5.4C188.37,5.03,169.62,5,140.53,5Z",
    fill: "#808184"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapSwitchEmpty);
export default __webpack_public_path__ + "static/media/air_gap_switch_empty.ff1717c75cde54a98ab985dab4af023f.svg";
export { ForwardRef as ReactComponent };